import { Link } from "react-router-dom";
import { ArrowUpRight, Newspaper } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/site/Motion";

const stamp = (item) => {
  const t = Date.parse(item.date_label || "");
  return Number.isNaN(t) ? 0 : t;
};

export default function NewsStrip({ items }) {
  const latest = [...(items || [])].sort((a, b) => stamp(b) - stamp(a) || (b.order || 0) - (a.order || 0)).slice(0, 3);
  if (latest.length === 0) return null;

  return (
    <section data-testid="news-strip" className="border-b border-ash bg-white/40">
      <div className="mx-auto max-w-[1440px] px-5 py-12 md:px-10 md:py-16">
        <Reveal className="flex flex-wrap items-end justify-between gap-4">
          <Eyebrow>In the news</Eyebrow>
          <Link
            to="/media"
            data-testid="news-strip-all"
            className="group inline-flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.14em] text-obsidian transition-colors duration-200 hover:text-progress"
          >
            All coverage
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>
        <div className="mt-8 grid gap-px border border-ash bg-ash md:grid-cols-3">
          {latest.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.06} className="bg-paper">
              <Link
                to="/media"
                data-testid={`news-strip-item-${item.id}`}
                className="group flex h-full items-start gap-5 p-6 transition-colors duration-300 hover:bg-paper/60 md:p-7"
              >
                <div className="h-20 w-16 shrink-0 overflow-hidden border border-ash bg-white">
                  {item.clipping_image ? (
                    <img
                      src={item.clipping_image}
                      alt={`${item.publication} clipping`}
                      loading="lazy"
                      className="h-full w-full object-cover object-top grayscale transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                  ) : (
                    <div className="flex h-full w-full items-center justify-center text-slategray">
                      <Newspaper size={18} />
                    </div>
                  )}
                </div>
                <div className="min-w-0">
                  <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-slategray">
                    {item.publication}
                    {item.date_label && <span className="ml-1 font-medium normal-case tracking-normal">· {item.date_label}</span>}
                  </p>
                  <h3 className="mt-2 font-serif text-lg font-medium leading-snug tracking-tight text-obsidian transition-colors duration-200 group-hover:text-progress md:text-xl">
                    {item.headline}
                  </h3>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
